<template>
  <button
    @click="getData"
    :class="[classes]"
    class="tw-flex tw-gap-x-3 hover:tw-bg-transparent tw-text-[#4D84FF] hover:tw-text-[#4D84FF] tw-font-CircularStd-medium tw-font-medium tw-underline tw-h-12 tw-items-center tw-min-w-max tw-block"
  >
    <img
      src="https://res.cloudinary.com/djalafcj9/image/upload/v1666018380/getequityV2/csv-icon_gcv1by.png"
      alt="csv icon"
    />
    Export list of {{ docType }}
  </button>
</template>

<script>
  import countryCode from "@/utils/json/countryCode.json";

  import { formatISODate } from "@/utils/helpers.js";
  export default {
    name: "ExportToCSV",
    data() {
      return {
        countryCode,
        csvData: null,
      };
    },
    props: {
      classes: {
        type: String,
        required: false,
        default: () => {
          return "";
        },
      },
      docType: {
        type: String,
        required: true,
      },
      fileName: {
        type: String,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
    },
    methods: {
      formatISODate,
      convertToCsv(headers, values) {
        // Empty array for storing the values
        const csvRows = [];

        // As for making csv format, headers
        // must be separated by comma and
        // pushing it into array
        csvRows.push(headers.join(","));

        // Pushing Object values into array
        // with comma separation
        csvRows.push(...values);

        // Returning the array joining with new line
        this.csvData = csvRows.join("\n");
        this.downloadCsv(this.csvData);
      },
      getData() {
        let values = null;
        const headers = this.getCsvHeader(this.docType);
        switch (this.docType) {
          case "Members":
            values = this.parseMembers();
            break;
          case "Investors":
            values = this.parseInvestors();
            break;
          case "Employees":
            values = this.parseEmployees();
            break;
        }
        this.convertToCsv(headers, values);
      },
      getCsvHeader(type) {
        let headers = null;
        switch (type) {
          case "Members":
            headers = [
              "Full Name",
              "Email",
              "username",
              "phone",
              "Home Address",
              "country",
            ];
            break;
          case "Investors":
            headers = ["Full Name", "Email", "Investment Amount", "phone"];
            break;
          case "Employees":
            headers = [
              "Full Name",
              "Stock Type",
              "Role",
              "Email",
              "Allocated Shares",
              "Vested Shares",
              "Exercised Shares",
              "Vesting Period",
              "Vesting Frequency",
              "Strike Price",
              "Start Date",
              "Exercise Timeline",
            ];
        }
        return headers;
      },
      parseMembers() {
        const data = this.data;
        const rawData = Object.values(data).map((value) => {
          const fullName = this.replaceCommas(
            `${value.user.fname} ${value.user.lname}`
          );
          const email = this.replaceCommas(value.user.email);
          const username = this.replaceCommas(value.user.username || "---");
          const phone = this.replaceCommas(value.user.phone || "---");
          const homeAddress = this.replaceCommas(value.user.homeAddress);
          const country = value.user.country
            ? this.replaceCommas(this.getCountryInfo(value.user.country).name)
            : "---";
          const data = [fullName, email, username, phone, homeAddress, country];
          return data.join(",");
        });
        return rawData;
      },
      parseInvestors() {
        const data = this.data;
        const rawData = Object.values(data).map((value) => {
          const fullName = this.replaceCommas(`${value.fname} ${value.lname}`);
          const email = this.replaceCommas(value.email);
          const investmentAmount = this.replaceCommas(String(value.usd_value));
          const phone = this.replaceCommas(String(value.phone));
          const data = [fullName, email, investmentAmount, phone];
          return data.join(",");
        });
        return rawData;
      },
      parseEmployees() {
        const data = this.data;
        //filter by status
        const validData = data.filter((employee) => {
          return (
            employee.status !== "Terminated" && employee.status !== "Rejected"
          );
        });
        const rawData = Object.values(validData).map((value) => {
          const fullName = this.replaceCommas(value.invitation.name);
          const stockType = this.replaceCommas(
            value.employee_type === "ESOP_EMPLOYEE" ? "ESO" : "RSU"
          );
          const role = this.replaceCommas(value.role);
          const email = this.replaceCommas(value.email);
          const allocatedShares = this.replaceCommas(
            String(value.allocated_shares)
          );
          const vestedShares = this.replaceCommas(
            String(value.employee?.vested_shares) || "---"
          );
          const exercisedShares = this.replaceCommas(
            String(value.employee?.exercised_amount) || "---"
          );
          const vestingPeriod = this.replaceCommas(
            `${value.vesting_duration} years`
          );
          const vestingFrequency = this.replaceCommas(
            this.vestingFrequency(value.vesting_frequency)
          );
          const strikePrice = this.replaceCommas(String(value.strike_price));
          const startDate = this.replaceCommas(
            this.formatISODate(value.start_date)
          );
          const exerciseTimeline = this.replaceCommas(
            `${value.exercise_timeline} Months`
          );
          const data = [
            fullName,
            stockType,
            role,
            email,
            allocatedShares,
            vestedShares,
            exercisedShares,
            vestingPeriod,
            vestingFrequency,
            strikePrice,
            startDate,
            exerciseTimeline,
          ];
          return data.join(",");
        });
        return rawData;
      },
      replaceCommas(value) {
        const re = /,/gi;
        if (value) {
          return value.replace(re, "");
        }
      },

      vestingFrequency(value) {
        let frequency = null;
        switch (Number(value)) {
          case 1:
            frequency = "Daily";
            break;
          case 30:
            frequency = "Monthly";
            break;
          case 91:
            frequency = "Quarterly";
          case 182:
            frequency = "Bi-annually";
          case 365:
            frequency = "Yearly";
            break;
        }
        return frequency;
      },
      getCountryInfo(countryCode) {
        const country = this.countryCode.countries.filter(
          (country) =>
            country.code === countryCode || country.name === countryCode
        )[0];
        return country;
      },
      downloadCsv(data) {
        // Creating a Blob for having a csv file format
        // and passing the data with type
        const blob = new Blob([data], { type: "text/csv" });

        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);

        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute(
          "download",
          `${this.fileName.toLowerCase()} ${this.docType.toLowerCase()} list.csv`
        );

        // Performing a download with click
        a.click();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
